import React from 'react';

import styled from '@emotion/styled';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
//import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';

import DupontButton from './../DupontButton';

import './index.scss';

export const DIALOG_ACTIONS = {
  CONFIRM: 'CONFIRM',
  CANCEL: 'CANCEL',
  RESET: 'RESET',
};

const StyledDialogActions = styled(DialogActions)`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 14px;
  padding: 24px 48px 0 48px;

  @media (max-width: 768px) {
    padding: 16px 32px 0 32px;

    .dialog-btn {
      font-size: 12px;
    }
  }
`;

export interface DupontDialogProps extends DialogProps {
  onDialogClose?: any;
  title?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  resetBtnText?: string;
  className?: string;
  confirmDisabled?: boolean;
  subTitle?: string | TrustedHTML;
  variant?: string;
  isOverlayLoader?: boolean;
  customHeader?: any;
  footerContent?: any;
}

const DupontDialog = (props: DupontDialogProps) => {
  const {
    open,
    onDialogClose,
    title,
    confirmBtnText,
    cancelBtnText,
    resetBtnText,
    confirmDisabled,
    variant,
    subTitle,
    maxWidth,
    PaperProps,
    customHeader,
    footerContent,
  } = props;
  const theme = useTheme();
  const btnColor = variant === 'primary' ? 'white' : variant;
  const descriptionElementRef = React.useRef<HTMLElement>(null);

  const closeBtnHandler = (event: object, reason = '') => {
    if ((reason && reason == 'backdropClick') || reason == 'escapeKeyDown') return;
    onDialogClose(DIALOG_ACTIONS.CANCEL);
  };
  const confirmBtnHandler = () => onDialogClose(DIALOG_ACTIONS.CONFIRM);
  const resetBtnHandler = () => onDialogClose(DIALOG_ACTIONS.RESET);
  const getDialogTheme = () => `dupont-dialog--${variant || 'default'}`;

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      onClose={closeBtnHandler}
      aria-labelledby={title}
      open={open}
      maxWidth={maxWidth}
      scroll='paper'
      PaperProps={PaperProps}
      className={`dupont-dialog ${getDialogTheme()} ${props.className}`}
    >
      <DialogTitle id='dialog-title' sx={{ padding: '0' }}>
        {customHeader ? (
          customHeader
        ) : (
          <>
            {title && <div className='dupont-dialog__title'>{title}</div>}
            {subTitle && <div className='dupont-dialog__subTitle' dangerouslySetInnerHTML={{ __html: subTitle }} />}
          </>
        )}
      </DialogTitle>

      <DialogContent>
        {/* <DialogContentText id='dialog-body' ref={descriptionElementRef} tabIndex={-1}> */}
        <main className='dupont-dialog__body font-not-sans'> {props.children} </main>
        {/* </DialogContentText> */}
      </DialogContent>

      <StyledDialogActions id='dialog-footer' theme={theme}>
        {cancelBtnText && (
          <DupontButton
            id='dialogCancelBtn'
            variant='outlined'
            className='dialog-btn'
            type='secondary'
            onClick={closeBtnHandler}
            color={btnColor}
            size='large'
          >
            {cancelBtnText}
          </DupontButton>
        )}
        {resetBtnText && (
          <DupontButton
            id='dialogResetBtn'
            className='dialog-btn'
            variant='outlined'
            onClick={resetBtnHandler}
            color={btnColor}
            size='large'
          >
            {resetBtnText}
          </DupontButton>
        )}
        {confirmBtnText && (
          <DupontButton
            id='dialogSubmitBtn'
            variant='contained'
            type='primary'
            disabled={confirmDisabled}
            onClick={confirmBtnHandler}
            color={btnColor}
            size='large'
            disableElevation
            className='dialog-btn'
          >
            {confirmBtnText}
          </DupontButton>
        )}
      </StyledDialogActions>
      {footerContent}
    </Dialog>
  );
};

export default DupontDialog;
